module.exports = __webpack_public_path__ + "img/red_arrow.b13b62e1.svg";